import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';
import { CalculatorComponent } from './calculator.component';

@NgModule({
  declarations: [CalculatorComponent],
  imports: [CommonModule, SharePipesModule, ThemeColorDirective],
  exports: [CalculatorComponent],
})
export class CalculatorModule {}
